import { firstName, fmtDate } from '../lib/format';
import { AbrechnungBar } from './abrechnung/AbrechnungBar';
import { MandantenKpi } from './accounts/MandantenKpi';
import { RegistrationCard } from './accounts/RegistrationCard';
import { AnfragenBar } from './anfragen/AnfragenBar';
import { TeamStatus } from './accounts/TeamStatus';
import { BelegeBars } from './belege/BelegeBars';
import { BelegeKpi } from './belege/BelegeKpi';
import { BriefeBar } from './briefe/BriefeBar';
import { ChatBar } from './chat/ChatBar';
import { useKanzlei } from './context';
import { DokumenteCard } from './dokumente/DokumenteCard';
import { FristenCard, FristenKpi } from './fristen/FristenCard';
import { LohnBar } from './lohn/LohnBar';

// Übersicht der Kanzlei: Hinweisleisten (Chat, Belege, neue Mitarbeiter, Briefe, Anfragen, für den Admin „Rechnung noch
// nicht geschrieben“), Begrüßung, neue Registrierungen, Kennzahlen, „Nächste Fristen“, „Dokumente“ (neue Briefe,
// Unterschriften), für den Admin dazu die Chef-Übersicht „Team im Blick“.
export function Home() {
  const { me } = useKanzlei();
  const admin = me.user.isAdmin;
  return (
    <>
      <ChatBar />
      <BelegeBars />
      <LohnBar />
      <BriefeBar />
      <AnfragenBar />
      {admin && <AbrechnungBar />}
      <div className="head">
        <div>
          <h1>Guten Tag, {firstName(me.user.name)}</h1>
          <p>
            {admin ? 'Alle Mandanten der Kanzlei' : 'Ihre Mandanten'} · Stand {fmtDate(new Date())}
          </p>
        </div>
      </div>
      {admin && <RegistrationCard />}
      <div className="kpis">
        <FristenKpi />
        <BelegeKpi />
        <MandantenKpi />
      </div>
      <FristenCard />
      <DokumenteCard />
      {admin && <TeamStatus />}
    </>
  );
}
